// Utils
import cn from '../../../utils/cn';

// Components
import IconButton from '../../atoms/IconButton/IconButton';
// Styles
import styles from './ConditionalFiltersItem.module.css';

/**
 * ConditionalFiltersItem – basic row renderer for a conditional filter
 * @param {object} props
 * @param {() => void} [props.onRemove]
 * @param {string} [props.className]
 * @param {boolean} [props.required]
 * @param {React.ReactNode} props.children
 * @returns {JSX.Element}
 */
function ConditionalFiltersItems({
  onRemove = () => {}, className = '', children, required = false,
}) {
  return (
    <div className={`${styles.row} ${className}`}>
      <div className={styles['row-children']}>
        {children}
      </div>
      {required ? (
        <span className={styles['remove-spacer']} aria-hidden />
      ) : (
        <IconButton
          icon="trash-empty"
          color="transparent"
          size="medium"
          onClick={onRemove}
          aria-label="Delete"
          className={styles.remove}
        />
      )}
    </div>
  );
}

/**
 * ConditionalFiltersItem – basic row renderer for a conditional filter
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {string} [props.className]
 * @param {boolean} [props.hasValue]
 * @param {boolean} [props.isFlex]
 * @returns {JSX.Element}
 */
export function ConditionalFiltersItem({
  children, isFlex = false, className = '', hasValue = true,
}) {
  return (
    hasValue ? (
      <div className={cn([styles.item,
        hasValue && styles['has-value'],
        isFlex && styles['is-flex'], className])}
      >
        {children}
      </div>
    ) : null
  );
}

export default ConditionalFiltersItems;
